<template>
  <div style="width: 1200px; margin: 0 auto; border-radius: 25px">
    <Title :title="{ name: '审核流程配置', path: '/flow/line' }"></Title>
    <div style="margin: 10px auto">
      <el-card class="box-card">
        <el-row :gutter="20" style="margin-left: 10px">
          <el-col :span="6">
            <el-select v-model="qparam.flowId" placeholder="请选择">
              <el-option
                v-for="item in flowData"
                :key="item.flowId"
                :label="item.flowName"
                :value="item.flowId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="getFlowLineList"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div style="margin: 10px auto">
      <el-card class="box-card" style="min-height: 650px">
        <el-table
          :data="tableData"
          :header-cell-style="{
            background: 'rgb(245,245,245)',
            color: 'black',
          }"
          :cell-style="{ color: 'black' }"
        >
          <el-table-column prop="sequence" label="顺序号" align="center">
          </el-table-column>
          <el-table-column label="审核人类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.flowNodeUserType === 1">特定人员</span>
              <span v-if="scope.row.flowNodeUserType === 2">指定角色</span>
              <span v-if="scope.row.flowNodeUserType === 3">项目负责人</span>
              <span v-if="scope.row.flowNodeUserType === 4"
                >部门逐级审批</span
              >
              <span v-if="scope.row.flowNodeUserType === 5">部门负责人</span>
              <span v-if="scope.row.flowNodeUserType === 6">动态审核人</span>
            </template>
          </el-table-column>
          <el-table-column label="特定审核人员" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.flowNodeUserType !== 1">无</span>
              <span v-else>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleClick(JSON.parse(JSON.stringify(scope.row)), 1)"
                >编辑</el-button
              >
              <el-popconfirm
                v-if="
                  scope.row.sequence === tableData.length &&
                  scope.row.sequence !== 1
                "
                style="margin: 0 10px"
                title="确定删除该审核流程吗？"
                @confirm="removeLine(scope.row.flowLineId)"
              >
                <el-button slot="reference" type="text" size="small"
                  >删除</el-button
                >
              </el-popconfirm>
              <el-button
                v-if="scope.row.sequence === tableData.length"
                type="text"
                size="small"
                @click="handleClick(scope.row, 2)"
                >追加</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 100%">
          <div style="float: right">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="qparam.current"
              :page-size="qparam.size"
              layout="prev, pager, next"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="drawer"
      :direction="direction"
      :close-on-click-modal="false"
      width="30%"
    >
      <div style="width: 80%; margin: 0 auto">
        <el-form
          ref="form"
          :model="flowLine"
          label-position="top"
          style="margin: 0 10px"
        >
          <el-form-item label="审核顺序:" style="width: 100%" prop="sequence">
            <el-input v-model="flowLine.sequence" disabled></el-input>
          </el-form-item>
          <el-form-item
            label="审核人类型:"
            style="width: 100%"
            prop="dealtTitle"
          >
            <el-radio-group v-model="flowLine.flowNodeUserType">
              <el-radio :label="1">特定人员</el-radio>
              <!--                            <el-radio :label="2">指定角色</el-radio>-->
              <el-radio :label="3">项目负责人</el-radio>
              <el-radio :label="5">部门负责人</el-radio>
              <el-radio :label="6">动态审核人员</el-radio>
              <el-radio :label="4">部门逐级审批</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="特定人员"
            style="width: 100%"
            prop="userId"
            v-if="flowLine.flowNodeUserType == 1"
          >
            <el-select
              v-model="flowLine.userId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in allSysUser"
                :key="item.userId"
                :label="item.realName"
                :value="item.userId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="指定角色"
            style="width: 100%"
            prop="roleId"
            v-if="flowLine.flowNodeUserType == 2"
          >
            <el-select
              v-model="flowLine.roleId"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in allSysRole"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注:" prop="remarks">
            <el-input
              type="textarea"
              v-model="flowLine.remark"
              :rows="2"
              style="width: 100%"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin: 50px auto 0 auto">
            <el-button type="warning" size="small" @click="drawer = false"
              >取消</el-button
            >
            <el-button type="primary" size="small" @click="handleSave"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../../Title";
import {
  requestAddOrEditFlowLine,
  requestFlowList,
  requestLineList,
  requestRemoveFlowLine,
  requestRoleList,
  requestUserGet,
} from "../../../api";

export default {
  components: { Title },
  data() {
    return {
      qparam: {
        flowId: 1,
        current: 1,
        size: 10,
      },
      totalCount: 0,
      add: false,
      title: "",
      type: "",
      flowLine: {
        flowNodeUserType: 1,
      },
      drawer: false,
      direction: "rtl",
      tableData: [],
      allSysRole: [],
      allSysUser: [],
    };
  },
  computed: {
    ...mapState(["flowData"]),
  },
  methods: {
    handleCurrentChange(val) {
      this.qparam.current = val;
      this.getFlowLineList();
    },
    async removeLine(flowLineId) {
      let res = await requestRemoveFlowLine({ flowLineId: flowLineId });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getFlowLineList();
      } else {
        this.$message.error(res.msg);
      }
    },
    handleClick(row, type) {
      this.type = type;
      if (type == 2) {
        this.title = "追加审核流程";
        this.drawer = true;
        this.flowLine = {
          sequence: row.sequence + 1,
          flowId: row.flowId,
          parentId: row.flowLineId,
        };
      } else if (type == 1) {
        this.title = "编辑审核流程";
        this.drawer = true;
        this.flowLine = row;
      } else {
        this.add = true;
      }
    },
    async handleSave() {
      this.drawer = false;
      let res = await requestAddOrEditFlowLine(this.flowLine);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getFlowLineList();
      } else {
        this.$message.error(res.msg);
      }
    },
    async getFlowLineList() {
      const res = await requestLineList(this.qparam);
      if (res.code == 200) {
        this.totalCount = res.total;
        this.tableData = res.rows;
      } else {
        this.$message.error(res.msg);
      }
    },
    async getRoleList() {
      let res = await requestRoleList();
      if (res.code == 200) {
        this.allSysRole = res.object;
      } else {
        this.$message.error(res.msg);
      }
    },
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code == 200) {
        this.allSysUser = res.object;
      } else {
        this.$message.error("获取人员列表失败");
      }
    },
  },
  created() {
    this.getFlowLineList();
    this.getRoleList();
    this.loadSysUserData();
  },
};
</script>
<style>
.el-drawer__body {
  overflow: auto;
  /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}
</style>
